module.exports = __webpack_public_path__ + "img/9.4c95132f.png";